import "./Styles/listing-channels.scss";
import "react-toggle/style.css";

import config from "../../app.json";
import axios from "axios";
import Pagination from "../../Components/Pagination/pagination";

import { Context } from "../../Reducers/Store";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import ChannelCard from "../../Components/ChannelCard/channel-card";

function ListingChannels() {
  const [state, dispatch] = useContext(Context);
  let navigate = useNavigate();
  const [cards, setCards] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 8;

  const fetchChannels = () => {
    axios
      .post(config.API + "/api/channel/getChannels", { 
        page: currentPage,
        perPage: itemsPerPage,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {
          if (res.data.values.$values.length) {
            setTotalItems(res.data.total);
          } else {
            setTotalItems(0);
          }

          res.data.values.$values.map(i => {
            if (!window._channelsIds.includes(i.id))
              window._channelsIds.push(i.id);
          });

          setCards(res.data.values.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    fetchChannels();
  }, [0]);

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    fetchChannels();
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const paginationElement = cards && cards.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row>
      <Col className="col-md-11">
        <Row className="listing-channels-container">
          <Col className="col-md-12">
            <Button
              onClick={() => navigate("/addNewChannel", { replace: false })}
              className="add-new-btn mt-4 mb-4"
            >
              Add new
            </Button>
          </Col>
        </Row>
        <Row>
          {cards?.map((x, index) => (
            <Col className="col-md-3 mb-4">
              <ChannelCard
                {...x}
                index={index}
                deleteApiPath={`/api/channel/deleteChannel`}
                onDelete={fetchChannels}
                deleteMessage={`The Channel has been successfully deleted`}
                manageChannel={true}
              />
            </Col>
          ))}
          {(!cards || !cards.length) && <Col className="col-md-6"><div className="empty-state-card" >There are no registered channels</div></Col>}

          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default ListingChannels;
